import { Injectable } from '@angular/core';
import { UserInterface } from 'app/models/user.model';
import { DataTransformAbstractGet } from 'app/modules/global/classes/data.transform.abstract.up';

@Injectable({
  providedIn: 'root',
})
export class UserDataTransformGet extends DataTransformAbstractGet {
  transform(user: UserInterface): UserInterface {
    return user;
  }
}
